// find status definitions on https://bagonboard.atlassian.net/wiki/spaces/PRD/pages/958496769/Definitions+for+bag+service+invoice+and+order+status
const ORDER_STATUS = {
  OPEN     : 'open',
  AWAITING : 'awaiting',
  CONFIRMED: 'confirmed',
  CLOSED   : 'closed',
} as const;

export type OrderStatus = typeof ORDER_STATUS;

export const ORDER_UNCONFIRMED_STATUSES = [
  ORDER_STATUS.AWAITING,
  ORDER_STATUS.OPEN,
];

export default ORDER_STATUS;
